import clsx from 'clsx'
import React from 'react'

import NotificationsMenu from '../Notification'

import useStyles from './styles'

interface NotificationBarProps {
  setOpen?: (open: boolean) => void
  className?: string
  fullHeigth?: boolean
  useSmallDot?: boolean
}
const NotificationBar: React.FC<NotificationBarProps> = ({
  setOpen = () => {},
  className,
  fullHeigth = false,
  useSmallDot = false
}) => {
  const targetRef = React.useRef()

  const classes = useStyles()

  return (
    <div
      ref={targetRef}
      className={clsx(classes.root, className)}
      data-testid='notifications-menu'
    >
      <NotificationsMenu
        targetRef={targetRef}
        setOpen={setOpen}
        fullHeigth={fullHeigth}
        useSmallDot={useSmallDot}
      />
    </div>
  )
}

export default NotificationBar
